import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(() => ({
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '16px 40px 0 16px'
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    flexWrap: 'wrap'
  },
  button: {
    position: 'absolute',
    right: 1,
    top: 1,
    color: 'gray'
  },
  layoutName: {
    textAlign: 'left'
  },
  changeImageButton: {
    textTransform: 'none'
  },
  containerImage: {
    padding: 16,
    display: 'flex',
    justifyContent: 'center',
    overflow: 'auto',
    maxHeight: '70vh'
  },
  image: {
    objectFit: 'contain',
    width: '100%',
    minWidth: 250,
    maxWidth: 700,
    maxHeight: '80vh',
    height: 'auto',
    display: 'block'
  },
  actionsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '0 16px 16px 16px'
  }
}))

export default useStyles
